import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { ScrollElement } from '@/components/functional/Scroll/ScrollElement/ScrollElement';
import { HOTLINE_INTERVIEW_STATUS_COMPLETED } from '@/feature/hotline/constant/interviewStatus';
import { HotlineProDetailViewLayout } from '@/feature/hotline/professional/detail/component/HotlineProDetailViewLayout';
import { HotlineProAfterMeetingContent } from '@/feature/hotline/professional/detail/meeting/component/HotlineProAfterMeetingContent';
import { HotlineProBeforeMeetingContent, } from '@/feature/hotline/professional/detail/meeting/component/HotlineProBeforeMeetingContent';
import { hotlineProDetailMeetingViewStyle } from '@/feature/hotline/professional/detail/meeting/page/style';
import { isScheduleFixedDetailData } from '@/feature/hotline/professional/detail/util/typeGuard';
import { scrollToWithHeaderHeight } from '@/helpers/ScrollUtils';
import { useLocation } from '@/hooks/lib/react-router/useLocation';
/** 内容表示部分のスクロール name */
export const HOTLINE_PRO_DETAIL_MEETING_SCROLL_CONTENT = 'scroll_content';
/**
 * 匿名ホットライン 面談実施ページ（View 部分のみ）
 * @description View 全体の表示, api 取得データを表示用に変換して渡す
 */
export const HotlineProDetailMeetingView = (props) => {
    const { detailData, onSubmitCancel, onSubmitScheduleChange, onSubmitUpdateRequest, } = props;
    const { hash } = useLocation();
    // ハッシュがある場合はスクロール
    useEffect(() => {
        if (hash) {
            scrollToWithHeaderHeight(hash.replace('#', ''));
        }
    }, [hash]);
    const style = hotlineProDetailMeetingViewStyle();
    return (_jsx(HotlineProDetailViewLayout, Object.assign({ detailData: detailData }, { children: _jsx(ScrollElement, Object.assign({ name: HOTLINE_PRO_DETAIL_MEETING_SCROLL_CONTENT }, { children: _jsx("div", Object.assign({ className: style.content() }, { children: isScheduleFixedDetailData(detailData) ? (
                // 面談実施前
                _jsx(HotlineProBeforeMeetingContent, { completedRequestInterviews: detailData.hotline_request.completed_hotline_request_interviews, interviewData: detailData.hotline_request.hotline_request_interview, onSubmitCancel: onSubmitCancel, onSubmitScheduleChange: onSubmitScheduleChange, onSubmitUpdateRequest: onSubmitUpdateRequest, requestId: detailData.hotline_request.id })) : (
                // 面談実施後
                _jsx(HotlineProAfterMeetingContent, { completedRequestInterviews: detailData.hotline_request.completed_hotline_request_interviews, isCompleted: detailData.hotline_request.hotline_request_interview.status ===
                        HOTLINE_INTERVIEW_STATUS_COMPLETED.value })) })) })) })));
};
